import { constants } from "../common";
import { hasV2Basket } from "./hasV2Basket";

export async function getBasketUrl(): Promise<string> {
  if (await hasV2Basket()) {
    return constants.urls.basketV2.add;
  } else {
    return constants.urls.basketV2.create;
  }
}
